module.exports = __webpack_public_path__ + "static/media/fam05.d9bdb94f.jpg";